(function() {
    'use strict';

    var _createClass = function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }
    var DpType = function () {
        function DpType(name, systemType) {
            _classCallCheck(this, DpType);

            this.name = name;
            this.systemType = systemType;
        }

        _createClass(DpType, [{
            key: 'toString',
            value: function toString() {
                return 'DpType.' + this.name;
            }
        }]);

        _createClass(DpType, [{
            key: 'getSystemType',
            value: function getSystemType() {
                return this.systemType;
            }
        }]);

        return DpType;
    }();

    DpType.Int = new DpType('Int', '[System.Int32, mscorlib]');
    DpType.Curve2d = new DpType('Curve2d', 'BMS.Shared.Model.System.Curve2d');
    DpType.DateTime = new DpType('DateTime', '[System.DateTime, mscorlib]');
    DpType.Bool = new DpType('Bool', '[System.Boolean, mscorlib]');
    DpType.String = new DpType('String', null);

    angular
        .module('app.controllers.device.functionHeating', [])
        .service("functionHeatingService", ['API', 'xCenterConfig', '$filter', '$q', '$timeout', '__Device',
            function(API, xCenterConfig, $filter, $q, $timeout, __Device) {
                this.params = undefined;
                this.actualDevice = undefined;
                this.heatingActive = undefined;
                this.functionHeatingModalDelay = undefined;

                /* 30 minutes */
                this.functionHeatingModalDelayTime = 30 * 60 * 1000;
                /* 30 seconds */
                this.functionHeatingRefreshPageTime = 30 * 1000;

                this.reset = function() {
                    this.params = undefined;
                    this.actualDevice = undefined;
                    this.heatingActive = undefined;
                };

                this.getParams = function() {
                    return this.params;
                };

                this.setParams = function(params) {
                    this.params = {};
                    this.params.deviceId = params.deviceId;
                    this.params.menuEntryId = params.menuEntryId;
                    this.params.device = params.device;
                };

                this.getActualDevicePromise = function(deviceId) {
                    var self = this;
                    var defer = $q.defer();

                    if (this.actualDevice === undefined) {
                        __Device.$byId(deviceId).$then(
                            function (data) {
                                this.$dispatch('build-view-datapoints').$dispatch('build-additional-datapoints');
                                self.actualDevice = data;
                                defer.resolve(data);
                            }
                        );
                    } else {
                        defer.resolve($q.when(self.actualDevice));

                    }

                    return defer.promise;
                };

                this.persist = function(datapoint, value) {
                    var api = new API();
                    var writeValuesParams = {
                        'DatapointValues': [{
                            '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[' + datapoint._Type.getSystemType() + '], BMS.Shared',
                            'DeviceId': this.actualDevice.DeviceId,
                            'DatapointConfigId': datapoint.DatapointConfigId,
                            'Value': value
                        }]
                    };
                    return api.Datapoint.WriteValues(writeValuesParams).$promise;
                };

                this.setFunctionHeating = function(active) {
                    this.heatingActive = active;
                };

                this.isHeatingActivePromise = function() {
                    var self = this;
                    var defer = $q.defer();

                    if (this.heatingActive === undefined) {
                        var dataPoints = [];
                        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingActive, _Type:DpType.Bool});

                        for (var point in dataPoints) {
                            if (dataPoints.hasOwnProperty(point)) {
                                dataPoints[point].DeviceId = self.actualDevice.DeviceId;
                            }
                        }

                        var dpValuesMap = {};

                        var api = new API();
                        var readValuesParams = { "DatapointValues": dataPoints, IgnoreErrors: false };
                        api.Datapoint.ReadValues(readValuesParams).$promise
                        .then(function (dpValues) {

                            dpValues.forEach(function(dp) {
                                dpValuesMap[dp.DatapointConfigId] = ($filter('filter')(dataPoints, { DatapointConfigId: dp.DatapointConfigId }, true))[0];
                                dpValuesMap[dp.DatapointConfigId]._Value = dp.Value;
                            });

                            self.heatingActive = dpValuesMap[xCenterConfig.datapointsBool.FunctionalHeatingActive]._Value;
                            defer.resolve(self.heatingActive);
                        }, function () {
                            console.warn('Error: Getting dpValues');
                        });
                    } else {
                        defer.resolve($q.when(self.heatingActive));
                    }
                    return defer.promise;
                };

                this.getFunctionHeatingModalDelay = function() {
                    return this.functionHeatingModalDelay;
                };

                this.activateFunctionHeatingModalDelay = function() {
                    var self = this;
                    this.functionHeatingModalDelay = true;
                    $timeout(function () {
                        self.functionHeatingModalDelay = undefined;
                    }, this.functionHeatingModalDelayTime);
                };
            }
        ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.functionheating', {
                    abstract: true,
                    url: '/functionHeating',
                    template: '<ui-view></ui-view>',
                    breadcrumb: {
                        ignore: true
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.functionheating.default', {
                    url: '/:menuEntryId/settings',
                    defaultParams: {menuEntryId: '00000000-0000-0000-0000-000000000000'},
                    templateUrl: 'views/device/device.functionHeating.html',
                    controller: 'DeviceFunctionHeatingCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: function () {
                            return 'NAV_FunctionHeating';
                        }
                    },
                    params: {
                        deviceId: undefined,
                        menuEntryId: undefined,
                        device: undefined
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.functionheating.curve', {
                    url: '/:menuEntryId/curve',
                    defaultParams: {menuEntryId: '00000000-0000-0000-0000-000000000000'},
                    templateUrl: 'views/device/device.functionHeating.curve.html',
                    controller: 'DeviceFunctionHeating_CurveCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: function () {
                            return 'NAV_FunctionHeatingCurve';
                        }
                    },
                    params: {
                        deviceId: undefined,
                        menuEntryId: undefined,
                        device: undefined
                    }
                });
        }])
        .controller('DeviceFunctionHeatingCtrl', DeviceFunctionHeatingCtrl)
        .controller('DeviceFunctionHeating_CurveCtrl', DeviceFunctionHeating_CurveCtrl)
        ;


















    /* @ngInject */
    function DeviceFunctionHeatingCtrl(
        functionHeatingService,
        $state,
        $stateParams,
        xCenterConfig,

        __MenuEntry,
        $translate,
        viewMenuBarService,

        API,
        $filter,
        dateTimePickerModal,
        ModalService,

        breadcrumbService,
        f_Interval,
        $scope,
        frontEndSettingsService
    ) {
        var vm = this;
        var localizations = {};

        vm.mks = {
            mk1: {
                id: 1,
                exists: false,
                switchedOn: false,
                disabled: false
            },
            mk2: {
                id: 2,
                exists: false,
                switchedOn: false,
                disabled: false
            },
            mk3: {
                id: 3,
                exists: false,
                switchedOn: false,
                disabled: false
            }
        };

        vm.mks.getExisting = function() {
            var existing = [];

            if (vm.mks.mk3.exists) {
                existing.push(vm.mks.mk3);
            }
            if (vm.mks.mk1.exists) {
                existing.push(vm.mks.mk1);
            }
            if (vm.mks.mk2.exists) {
                existing.push(vm.mks.mk2);
            }
            return existing;
        };

        vm.mks.getSwitchedOn = function() {
            var on = [];

            if (vm.mks.mk3.switchedOn) {
                on.push(vm.mks.mk3);
            }
            if (vm.mks.mk1.switchedOn) {
                on.push(vm.mks.mk1);
            }
            if (vm.mks.mk2.switchedOn) {
                on.push(vm.mks.mk2);
            }
            return on;
        };

        this.$onInit = function() {
            functionHeatingService.reset();
            functionHeatingService.setParams($stateParams);
            var actualDevice;

            functionHeatingService.getActualDevicePromise($stateParams.deviceId)
            .then(function(device) {
                actualDevice = device;

                var favoriteObject = {
                    favoriteType : 'MenuEntry',
                    favoriteObject:
                        __MenuEntry.$buildRaw({
                            "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                            "MenuEntryType": 3,
                            "MenuEntryId": 'c6a4ff37-ea92-4a67-ab0e-9e0218ecaf01',
                            "DeviceId": actualDevice.DeviceId,
                            'CustomActionName': 'FunctionHeating',
                            'DisplayName': $translate.instant('NAV_FunctionHeating'),
                            'ImageName': 'funktionsheizen',

                            $UI:{}
                        })
                };
                viewMenuBarService.setFavorite(favoriteObject);

                return prepareExternalHeaters(actualDevice);
            })
            .then(function(dpValues) {
                if (actualDevice) {
                    vm.areExternalHeatersAvailable = dpValues.some(function(dpValue) {
                        return (dpValue.Value && actualDevice.ConfigVersion && actualDevice.ConfigVersion > 3);
                    });
                }

                return $translate.onReady();
            })
            .then(function() {
                loadLocalizations();
                vm.PossibleValuesSettings = {
                     '0': localizations.Settings_CustomHumidity,
                     '1': localizations.Settings_ShortHumidity,
                     '2': localizations.Settings_LongHumidity,
                     '3': localizations.Settings_CombinedHumidity
                };



                if (!functionHeatingService.getFunctionHeatingModalDelay()) {
                    showWarning();
                } else {
                    loadPage();
                }
            })
            ;

        };

        function prepareExternalHeaters(actualDevice) {
            var dataPoints = [];
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_BivFreigabeSekHeizungHeizwasser, _Type:DpType.Bool});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_BivFreigabeSekHeizungHeizwasser2, _Type:DpType.Bool});

            for (var point in dataPoints) {
                if (dataPoints.hasOwnProperty(point)) {
                    dataPoints[point].DeviceId = actualDevice.DeviceId;
                }
            }

            var api = new API();
            var readValuesParams = { "DatapointValues": dataPoints, IgnoreErrors: false };
            return api.Datapoint.ReadValues(readValuesParams).$promise;
        }

        function showWarning() {
            var modalText = localizations.ModalTitle + '<br/><br/>' + localizations.ModalBody;

            ModalService.showModal({
                templateUrl: 'views/modals/yesNo.html',

                /* @ngInject */
                controller: function ($scope, close, ModalText) {
                    $scope.Text = ModalText;
                    $scope.close = function (a) {
                        close(a);
                    };
                },
                inputs: {
                    ModalText: modalText
                },
                locationChangeSuccess: 0

            }).then(function (modal) {
                modal.close.then(function (data) {
                    if (data) {
                        functionHeatingService.activateFunctionHeatingModalDelay();
                        loadPage();
                    } else {
                        breadcrumbService.goBack();
                    }
                });
            });
        }

        function loadPage() {
            var i = {
                'AppId': 'interval.functionHeatingRefreshPage',
                delay: functionHeatingService.functionHeatingRefreshPageTime,
                fn: loadData
            };
            vm.functionHeatingRefreshPage = f_Interval.registerInterval(i);

            loadData();
        }

        $scope.leaveView = function () {
            if (vm.functionHeatingRefreshPage) {
                f_Interval.unregisterIntervalByAppId(vm.functionHeatingRefreshPage);
            }
        };
        $scope.$on("$destroy", $scope.leaveView);

        function loadData() {
            functionHeatingService.heatingActive = undefined;
            functionHeatingService.getActualDevicePromise($stateParams.deviceId)
            .then(function(actualDevice) {
                var preparedDatapoints = prepareDatapoints(actualDevice);
                var dpValuesMap = {};

                var api = new API();
                var readValuesParams = { "DatapointValues": preparedDatapoints, IgnoreErrors: false };
                api.Datapoint.ReadValues(readValuesParams).$promise
                .then(function (dpValues) {

                    dpValues.forEach(function(dp) {
                        dpValuesMap[dp.DatapointConfigId] = ($filter('filter')(preparedDatapoints, { DatapointConfigId: dp.DatapointConfigId }, true))[0];
                        dpValuesMap[dp.DatapointConfigId]._Value = dp.Value;
                    });

                    assignValuesToView(dpValuesMap, actualDevice);

                    setMinimumHeatingCircuits(vm.mks, vm.isFunctionHeatingActive);
                    vm.editAllowed = !vm.isFunctionHeatingActive;

                    setMessage(vm.isFunctionHeatingActive, vm.startDatum);

                }, function () {
                    console.warn('Error: Getting dpValues');
                });
            });
        }

        function setMinimumHeatingCircuits(circuits, heatingActive) {
            if (!circuits.mk3.switchedOn && !circuits.mk1.switchedOn && !circuits.mk2.switchedOn && !heatingActive) {
                if (circuits.mk3.enabled) {
                    circuits.mk3.switchedOn = true;
                    functionHeatingService.persist(vm.mks.mk3.switchedOnDp, true);
                }
                else if (circuits.mk1.enabled) {
                    circuits.mk1.switchedOn = true;
                    functionHeatingService.persist(vm.mks.mk1.switchedOnDp, true);
                }
                else if (circuits.mk2.enabled) {
                    circuits.mk2.switchedOn = true;
                    functionHeatingService.persist(vm.mks.mk2.switchedOnDp, true);
                }
            }

            var onCircuits = vm.mks.getSwitchedOn();
            if (onCircuits.length === 1) {
                onCircuits[0].disabled = true;
            } else {
                onCircuits.forEach(function(circuit) {
                    circuit.disabled = false;
                });
            }

            var existing = vm.mks.getExisting();
            vm.isFunctionHeatingDisabled = (existing.length === 0 ? true : false);
        }


        vm.mkXSwitchChanged = function(returnParams) {
            returnParams.params.switchedOn = returnParams.value;
            functionHeatingService.persist(returnParams.params.switchedOnDp, returnParams.value);

            var existing = vm.mks.getExisting();

            if (returnParams.value === false) {
                var switchedOnCircuits = $filter('filter')(existing, { switchedOn: true }, true);

                if (switchedOnCircuits.length === 1) {
                    switchedOnCircuits[0].disabled = true;
                }
            }
            else {
                existing.forEach(function(circuit) {
                    circuit.disabled = false;
                });
            }

            vm.isFunctionHeatingDisabled = (existing.length === 0 ? true : false);
        };

        var areExternalHeatersActivatedDp;
        vm.externalHeatersSwitchChanged = function(returnParams) {
            functionHeatingService.persist(areExternalHeatersActivatedDp, returnParams.value);
        };

        function prepareDatapoints(actualDevice) {
            if (actualDevice !== undefined
                && actualDevice.DeviceOptions !== undefined
                && actualDevice.DeviceOptions.some(existInOptions.bind(null, xCenterConfig.deviceOptions.Heatpump_MK1))) {
                    vm.mks.mk1.exists = true;
            } else {
                vm.mks.mk1.exists = false;
            }
            if (actualDevice !== undefined
                && actualDevice.DeviceOptions !== undefined
                && actualDevice.DeviceOptions.some(existInOptions.bind(null, xCenterConfig.deviceOptions.Heatpump_MK2))) {
                    vm.mks.mk2.exists = true;
            } else {
                vm.mks.mk2.exists = false;
            }
            if (actualDevice !== undefined
                && actualDevice.DeviceOptions !== undefined
                && actualDevice.DeviceOptions.some(existInOptions.bind(null, xCenterConfig.deviceOptions.Heatpump_MK3))) {
                    vm.mks.mk3.exists = true;
            } else {
                vm.mks.mk3.exists = false;
            }

            var dataPoints = [];
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.FunctionalHeatingHeatingDays, _Type:DpType.Int});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.FunctionalHeatingRuns, _Type:DpType.Int});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsInt.FunctionalHeatingSettings, _Type:DpType.Int});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsCurve2d.FunctionalHeatingCurve, _Type:DpType.Curve2d});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsDateTime.FunctionalHeatingTimestamp, _Type:DpType.DateTime});

            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingActive, _Type:DpType.Bool});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingMK1Active, _Type:DpType.Bool});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingMK2Active, _Type:DpType.Bool});
            dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingHkActive, _Type:DpType.Bool});

            if (vm.areExternalHeatersAvailable && actualDevice.ConfigVersion && actualDevice.ConfigVersion > 3) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.FunctionalHeatingUseExternalHeaters, _Type:DpType.Bool});
            }
            if (vm.mks.mk1.exists) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsString.MK1Name, _Type:DpType.String});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_MK1Enabled, _Type:DpType.Bool});
            }
            if (vm.mks.mk2.exists) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsString.MK2Name, _Type:DpType.String});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_MK2Enabled, _Type:DpType.Bool});
            }
            if (vm.mks.mk3.exists) {
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsString.MK3Name, _Type:DpType.String});
                dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsBool.HP_MK3Enabled, _Type:DpType.Bool});
            }

            for (var point in dataPoints) {
                if (dataPoints.hasOwnProperty(point)) {
                    dataPoints[point].DeviceId = actualDevice.DeviceId;
                }
            }

            return dataPoints;
        }

        function existInOptions(constDeviceOptionId, element) {
            return (areGuidsEqual(element.OptionId, constDeviceOptionId) && element.IsActivated);
        }

        var chosenValueSettingsDdlDp;
        var menuDaysDp;
        var menuNumberOfRunsDp;
        var functionalHeatingActiveDp;
        var startDatumDp;
        var curveDp;

        function assignValuesToView(datapoints, actualDevice) {
            chosenValueSettingsDdlDp = datapoints[xCenterConfig.datapointsInt.FunctionalHeatingSettings];
            vm.chosenValueSettingsDdl = chosenValueSettingsDdlDp._Value.toString();

            menuDaysDp = datapoints[xCenterConfig.datapointsInt.FunctionalHeatingHeatingDays];
            vm.menuDays = menuDaysDp._Value;
            menuNumberOfRunsDp = datapoints[xCenterConfig.datapointsInt.FunctionalHeatingRuns];
            vm.menuNumberOfRuns = menuNumberOfRunsDp._Value;

            functionalHeatingActiveDp = datapoints[xCenterConfig.datapointsBool.FunctionalHeatingActive];
            vm.isFunctionHeatingActive = functionalHeatingActiveDp._Value;
            functionHeatingService.setFunctionHeating(vm.isFunctionHeatingActive);

            if (vm.areExternalHeatersAvailable && actualDevice.ConfigVersion && actualDevice.ConfigVersion > 3) {
                areExternalHeatersActivatedDp = datapoints[xCenterConfig.datapointsBool.FunctionalHeatingUseExternalHeaters];
                vm.areExternalHeatersActivated = areExternalHeatersActivatedDp._Value;
            }

            curveDp = datapoints[xCenterConfig.datapointsCurve2d.FunctionalHeatingCurve];

            startDatumDp = datapoints[xCenterConfig.datapointsDateTime.FunctionalHeatingTimestamp];
            vm.startDatum = moment(startDatumDp._Value);

            if (!vm.isFunctionHeatingActive || vm.startDatum.year().toString() === '0001') {
                vm.startDatum = moment().add(10, 'minutes').set({ second:0, millisecond:0 });
            }

            frontEndSettingsService.getFrontendSettings()
                .then((settings) => {
                    if (vm.mks.mk3.exists) {
                        vm.mks.mk3.name =  datapoints[xCenterConfig.datapointsString.MK3Name]._Value;
                        if (vm.mks.mk3.name && settings.LanguageCode === 'cs' && vm.mks.mk3.name === 'MK3') {
                            vm.mks.mk3.name = 'Topný okruh TO3';
                        }
                        vm.mks.mk3.nameVariable = (vm.mks.mk3.name ? vm.mks.mk3.name : 'CUSTOM_Device_FunctionHeating_Menu_Circuit3');
                        vm.mks.mk3.enabled = datapoints[xCenterConfig.datapointsBool.HP_MK3Enabled]._Value;
        
                        vm.mks.mk3.switchedOnDp = datapoints[xCenterConfig.datapointsBool.FunctionalHeatingHkActive];
                        vm.mks.mk3.switchedOn = (vm.mks.mk3.enabled ? vm.mks.mk3.switchedOnDp._Value : false);
                    }
                    if (vm.mks.mk1.exists) {
                        vm.mks.mk1.name =  datapoints[xCenterConfig.datapointsString.MK1Name]._Value;
                        if (vm.mks.mk1.name && settings.LanguageCode === 'cs' && vm.mks.mk1.name === 'MK1') {
                            vm.mks.mk1.name = 'Topný okruh TO1';
                        }
                        vm.mks.mk1.nameVariable = (vm.mks.mk1.name ? vm.mks.mk1.name : 'CUSTOM_Device_FunctionHeating_Menu_Circuit1');
                        vm.mks.mk1.enabled = datapoints[xCenterConfig.datapointsBool.HP_MK1Enabled]._Value;
        
                        vm.mks.mk1.switchedOnDp = datapoints[xCenterConfig.datapointsBool.FunctionalHeatingMK1Active];
                        vm.mks.mk1.switchedOn = (vm.mks.mk1.enabled ? vm.mks.mk1.switchedOnDp._Value : false);
                    }
                    if (vm.mks.mk2.exists) {
                        vm.mks.mk2.name =  datapoints[xCenterConfig.datapointsString.MK2Name]._Value;
                        if (vm.mks.mk2.name && settings.LanguageCode === 'cs' && vm.mks.mk2.name === 'MK2') {
                            vm.mks.mk2.name = 'Topný okruh TO2';
                        }
                        vm.mks.mk2.nameVariable = (vm.mks.mk2.name ? vm.mks.mk2.name : 'CUSTOM_Device_FunctionHeating_Menu_Circuit2');
                        vm.mks.mk2.enabled = datapoints[xCenterConfig.datapointsBool.HP_MK2Enabled]._Value;
        
                        vm.mks.mk2.switchedOnDp = datapoints[xCenterConfig.datapointsBool.FunctionalHeatingMK2Active];
                        vm.mks.mk2.switchedOn = (vm.mks.mk2.enabled ? vm.mks.mk2.switchedOnDp._Value : false);
                    }
                });
        }

        function setMessage(isHeatingActive, startDatum) {
            if (isHeatingActive) {
                /* Is the selected date in past or in future? */
                var ms = moment(startDatum).diff(moment());

                if (ms > 0) {
                    /* Future - heating is active, but has not started yet */
                    vm.message = 'CUSTOM_Device_FunctionHeating_Message_HeatingActiveWaiting';
                } else {
                    /* Past - heating is in progress, countdown runs */
                    var endDate = moment(startDatum).add(vm.menuDays * vm.menuNumberOfRuns, 'days');
                    var beginningDate = moment();

                    var numberOfDays = endDate.diff(beginningDate, 'days');
                    var heatingLength = endDate.diff(beginningDate);
                    var duration = moment.duration(heatingLength);

                    var dateStr = (numberOfDays > 0 ? numberOfDays + ' ' + localizations.DayShort + ' ' : '')
                                + (duration.hours() % 24 > 0 ? duration.hours() % 24 + ' ' + localizations.HoursShort + ' ' : '')
                                + (duration.minutes() > 0 ? duration.minutes() + ' ' + localizations.MinutesShort + ' ' : '')
                                + (numberOfDays === 0 ? duration.seconds() + ' ' + localizations.SecondsShort : '');

                    vm.numberOfDaysTranslationData = {
                        numberOfDays: dateStr
                    };

                    vm.message = 'CUSTOM_Device_FunctionHeating_Message_HeatingActiveXDaysRemaining';
                }



            } else {
                vm.message = 'CUSTOM_Device_FunctionHeating_Message_HeatingNotActive';
            }
        }

        vm.pickDate = function() {
            var d = moment(vm.startDatum);
            var endOfPreviousDay = moment().subtract(1, 'days').endOf('day');
            var options = {
                hideTime: false,
                filter: function(day) {
                    if (day.isSameOrAfter(endOfPreviousDay)) {
                        return true;
                    }
                    return false;
                }
            };
            dateTimePickerModal(d, options)
            .then(function(modal) {
                modal.close.then(function(data) {
                    if (data !== undefined) {
                        vm.startDatum = moment(data).set({ second:0, millisecond:0 });
                        functionHeatingService.persist(startDatumDp, data);
                        checkIfDateAndTimeAreInFuture();
                    }
                });
            });
        };

        vm.settingsDdlChanged = function(returnParams) {
            vm.chosenValueSettingsDdl = returnParams.value.toString();
            functionHeatingService.persist(chosenValueSettingsDdlDp, parseInt(returnParams.value, 10));

            updateHeatingCurve();
        };

        vm.returnToDevice = function() {
            var params = functionHeatingService.getParams();
            $state.go('device.entry', {
                'deviceId': params.deviceId,
                'menuEntryId': params.menuEntryId,
                'device': params.device
            });
        };

        function areGuidsEqual(guidA, guidB) {
            if(guidA.replace(/[{}]/g, "").toLowerCase() === guidB.replace(/[{}]/g, "").toLowerCase()) {
                return true;
            }
            return false;
        }

        vm.showCurve = function() {
            var params = functionHeatingService.getParams();
            $state.go('device.functionheating.curve', {
                'deviceId': params.deviceId,
                'menuEntryId': params.menuEntryId,
                'device': params.device
            });
        };

        vm.menuDaysOnBlur = function() {
            if (vm.menuDays < 2) {
                vm.menuDays = 2;
            }
            else if (vm.menuDays > 50) {
                vm.menuDays = 50;
            }
            functionHeatingService.persist(menuDaysDp, vm.menuDays);

            updateHeatingCurve();
        };

        function updateHeatingCurve() {
            if (vm.chosenValueSettingsDdl === '0') {
                calculateFunctionHeatingCurve(vm.menuDays);
            } else {
                presetFunctionHeatingCurve(vm.chosenValueSettingsDdl);
            }
        }

        function calculateFunctionHeatingCurve(menuDays) {
            var values = [];
            var i = 0;
            var j = 0;

            if (curveDp._Value.CurveValues) {
                var cvLength = curveDp._Value.CurveValues.length;
                if (cvLength >= menuDays) {
                    for (i; i < menuDays; i++) {
                        values.push( curveDp._Value.CurveValues[i] );
                    }
                } else {
                    for (i; i < cvLength; i++) {
                        values.push( curveDp._Value.CurveValues[i] );
                    }
                    for (j = i; j < menuDays; j++) {
                        values.push({ XValue: j, YValue: 25 });
                    }
                }
            } else {
                for (j = 0; j < menuDays; j++) {
                    values.push({ XValue: j, YValue: 25 });
                }
            }

            curveDp._Value.CurveValues = values;

            functionHeatingService.persist(curveDp, curveDp._Value);
        }

        function presetFunctionHeatingCurve(chosenValueSettingsDdl) {
            var values = [];

            var i = 0;
            if (chosenValueSettingsDdl === '1') {
                for (i = 0; i < 4; i++) {
                    values.push({ XValue: i, YValue: 25 });
                }
                for (i = 4; i < 9; i++) {
                    values.push({ XValue: i, YValue: 50 });
                }
                vm.menuDays = 9;

                functionHeatingService.persist(menuDaysDp, vm.menuDays);

                curveDp._Value.CurveValues = values;
                functionHeatingService.persist(curveDp, curveDp._Value);
            }

            if (chosenValueSettingsDdl === '2') {
                var point = 25;
                var point2 = 45;

                for (i = 0; i < 3; i++) {
                    values.push({ XValue: i, YValue: point + (i * 10) });
                    values.push({ XValue: i + 6, YValue: point2 - (i * 10) });
                }
                for (i = 3; i < 6; i++) {
                    values.push({ XValue: i, YValue: 50 });
                }
                vm.menuDays = 9;

                functionHeatingService.persist(menuDaysDp, vm.menuDays);

                curveDp._Value.CurveValues = values;
                functionHeatingService.persist(curveDp, curveDp._Value);
            }

            if (chosenValueSettingsDdl === '3') {
                for (i = 0; i < 4; i++) {
                    values.push({ XValue: i, YValue: 25 });
                }
                for (i = 4; i < 9; i++) {
                    values.push({ XValue: i, YValue: 50 });
                }
                for (i = 9; i < 12; i++) {
                    values.push({ XValue: i, YValue: 25 });
                }

                values.push({ XValue: 12, YValue: 35 });
                values.push({ XValue: 13, YValue: 45 });

                for (i = 14; i < 17; i++) {
                    values.push({ XValue: i, YValue: 50 });
                }

                values.push({ XValue: 17, YValue: 45 });
                values.push({ XValue: 18, YValue: 35 });
                values.push({ XValue: 19, YValue: 25 });

                vm.menuDays = 20;

                functionHeatingService.persist(menuDaysDp, vm.menuDays);

                curveDp._Value.CurveValues = values;
                functionHeatingService.persist(curveDp, curveDp._Value);
            }


        }

        vm.menuNumberOfRunsOnBlur = function() {
            if (vm.menuNumberOfRuns < 1) {
                vm.menuNumberOfRuns = 1;
            }
            else if (vm.menuNumberOfRuns > 20) {
                vm.menuNumberOfRuns = 20;
            }

            functionHeatingService.persist(menuNumberOfRunsDp, vm.menuNumberOfRuns);
        };

        vm.functionHeatingActiveSwitchChanged = function(returnParams) {
            vm.isFunctionHeatingActive = returnParams.value;
            functionHeatingService.setFunctionHeating(vm.isFunctionHeatingActive);
            functionHeatingService.persist(functionalHeatingActiveDp, vm.isFunctionHeatingActive);
            functionHeatingService.persist(startDatumDp, vm.startDatum);
            vm.editAllowed = !vm.isFunctionHeatingActive;
            setMessage(vm.isFunctionHeatingActive, vm.startDatum);
        };

        vm.isFunctionHeatingMouseover = function() {
            checkIfDateAndTimeAreInFuture();
        };

        function checkIfDateAndTimeAreInFuture() {
            var ms = moment(vm.startDatum).diff(moment());
            var duration = moment.duration(ms);

            if (duration <= 0) {
                vm.isFunctionHeatingDisabled = true;
                vm.messageTwo = 'CUSTOM_Device_FunctionHeating_Message_WrongTime';
            } else {
                vm.isFunctionHeatingDisabled = false;
                vm.messageTwo = undefined;
            }
        }

        function loadLocalizations() {
            localizations.Settings_CustomHumidity = $translate.instant('CUSTOM_Device_FunctionHeating_Settings_CustomHumidity');
            localizations.Settings_ShortHumidity = $translate.instant('CUSTOM_Device_FunctionHeating_Settings_ShortHumidity');
            localizations.Settings_LongHumidity = $translate.instant('CUSTOM_Device_FunctionHeating_Settings_LongHumidity');
            localizations.Settings_CombinedHumidity = $translate.instant('CUSTOM_Device_FunctionHeating_Settings_CombinedHumidity');
            localizations.DayShort = $translate.instant('GENERAL_Day_Short');
            localizations.HoursShort = $translate.instant('GENERAL_Hours_Short');
            localizations.MinutesShort = $translate.instant('GENERAL_Minutes_Short');
            localizations.SecondsShort = $translate.instant('GENERAL_Seconds_Short');

            localizations.ModalTitle = $translate.instant('CUSTOM_Device_FunctionHeating_Modal_Title');
            localizations.ModalBody = $translate.instant('CUSTOM_Device_FunctionHeating_Modal_Body');
        }
    }



























/* @ngInject */
function DeviceFunctionHeating_CurveCtrl($rootScope,
    $scope,
    $filter,
    API,
    xCenterConfig,

    f_User,
    __MenuEntry,

    viewMenuBarService,
    $stateParams,
    $translate,
    functionHeatingService
) {
    var vm = this;

    this.$onInit = function() {
        initializeData();
    };

    $scope.$on("$destroy", function(){
        functionHeatingService.reset();
    });

    var curveDp;

    function initializeData() {
        $scope.UserLevel = f_User.getUserLevel();
        functionHeatingService.getActualDevicePromise($stateParams.deviceId)
        .then(function(actualDevice) {
            var favoriteObject = {
                favoriteType: 'MenuEntry',
                favoriteObject: __MenuEntry.$buildRaw({
                    "$type": "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "MenuEntryId": 'c6a4ff37-ea92-4a67-ab0e-9e0218ecaf01',
                    "DeviceId": actualDevice.DeviceId,
                    'CustomActionName': 'FunctionHeatingCurve',
                    'DisplayName': $translate.instant('NAV_FunctionHeatingCurve'),
                    'ImageName': 'heizkurve',

                    $UI: {}
                })
            };
            viewMenuBarService.setFavorite(favoriteObject);

            functionHeatingService.isHeatingActivePromise()
            .then(function(isActive) {
                vm.editAllowed = !isActive;
            });

            var preparedDatapoints = prepareDatapoints(actualDevice);
            prepareCurve(preparedDatapoints);
        });

    }

    function prepareCurve(preparedDatapoints) {
        var dpValuesMap = {};
        $scope.curve = { Value: {} };

        var api = new API();
        var readValuesParams = { "DatapointValues": preparedDatapoints, IgnoreErrors: false };
        api.Datapoint.ReadValues(readValuesParams).$promise
        .then(function (dpValues) {

            dpValues.forEach(function(dp) {
                dpValuesMap[dp.DatapointConfigId] = ($filter('filter')(preparedDatapoints, { DatapointConfigId: dp.DatapointConfigId }, true))[0];
                dpValuesMap[dp.DatapointConfigId]._Value = dp.Value;
            });

            curveDp = dpValuesMap[xCenterConfig.datapointsCurve2d.FunctionalHeatingCurve];

            $rootScope.backbutton = true;
            $scope.yAxis = [];
            for (var i = 65; i >= 5; i = i - 5) {
                $scope.yAxis.push(i);
            }

            var r = {};
            r.Value = curveDp._Value;
            if (r.Value && r.Value.CurveValues) {
                r.Value.CurveValues = $filter('orderBy')(r.Value.CurveValues, '-XValue');
                $scope.curve = r;
            } else {
                $scope.curve.Value = undefined;
            }

            $scope.curve.$UI = { editMode: false };
            $scope.curve.desc = {
                xVal: {
                    type: 'day',
                    text: 'CUSTOM_Device_FunctionHeating_Curve_xBoxLabel'
                },
                yVal: {
                    type: 'temperature',
                    text: 'CUSTOM_Device_FunctionHeating_Curve_yBoxLabel'
                }
            };

        }, function () {
            console.warn('Error: Getting dpValues');
        });
    }

    $scope.editCurve = function(c) {
        $scope.tempCurve = angular.copy(c);
        c.$UI.editMode = true;
    };

    $scope.saveCurve = function(c) {
        c.$UI.editMode = false;
        functionHeatingService.persist(curveDp, c.Value);

        var chosenValueSettingsDdlDp = {'DatapointConfigId': xCenterConfig.datapointsInt.FunctionalHeatingSettings, _Type:DpType.Int};
        functionHeatingService.persist(chosenValueSettingsDdlDp, 0);
    };

    $scope.revertCurve = function(c) {
        c.Value = angular.copy($scope.tempCurve.Value);
        c.Value.CurveValues = angular.copy($scope.tempCurve.Value.CurveValues);
    };

    $scope.$on('UserlevelChange', function() {
        initializeData();
    });

    function prepareDatapoints(actualDevice) {
        var dataPoints = [];

        dataPoints.push({'DatapointConfigId': xCenterConfig.datapointsCurve2d.FunctionalHeatingCurve, _Type:DpType.Curve2d});

        for (var point in dataPoints) {
            if (dataPoints.hasOwnProperty(point)) {
                dataPoints[point].DeviceId = actualDevice.DeviceId;
            }
        }

        return dataPoints;
    }

}

})();
